module.exports = __webpack_public_path__ + "img/happy_works.1d4a9a24.png";